import BaseService from "./BaseService";

export enum QosServiceLevel {
    Highest = 0,
    Standard = 1,
    Bulk = 2,
}

export interface QosConfiguration {
    id: string;
    organizationId: string;
    organizationStructureMemberId: string;
    serviceLevel: QosServiceLevel;
    isActive?: boolean | null;
    createdOn?: string;
    modifiedOn?: string;
    deletedOn?: string | null;
    createdBy?: string;
    modifiedBy?: string;
}

class QosService extends BaseService {
    protected urlBase: string = "api/Qos";

    public async getQosConfigurations(): Promise<QosConfiguration[]> {
        return this.get(new URLSearchParams({}), "GetQosConfigurations");
    }

    public async createQosConfiguration(configuration: QosConfiguration) {
        return this.post<QosConfiguration>(
            JSON.stringify(configuration),
            new URLSearchParams({}),
            "CreateQosConfiguration",
            undefined,
            `CreateQosConfiguration-${configuration.id}`,
        );
    }

    public async updateQosConfiguration(
        id: string,
        configuration: QosConfiguration,
    ) {
        return this.put(
            new URLSearchParams({}),
            `UpdateQosConfiguration/${id}`,
            JSON.stringify(configuration),
            undefined,
            `UpdateQosConfiguration-${configuration.id}`,
        );
    }

    public async deleteQosConfiguration(id: string) {
        return this.delete(
            new URLSearchParams({}),
            `DeleteQosConfiguration/${id}`,
            undefined,
            undefined,
            `DeleteQosConfiguration-${id}`,
        );
    }
}

export default QosService;
